import React, { useState } from 'react'
import { login } from '../utils/firebase'
import { Loader2, LogIn, AlertCircle } from 'lucide-react'
import { APP_TAG } from '../version'

export default function Login() {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading]   = useState(false)
  const [error, setError]       = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    try {
      await login(email, password)
      // onAuthStateChanged en App.jsx redirige automáticamente
    } catch (err) {
      const msgs = {
        'auth/user-not-found':  'Usuario no encontrado',
        'auth/wrong-password':  'Contraseña incorrecta',
        'auth/invalid-email':   'Email inválido',
        'auth/too-many-requests': 'Demasiados intentos. Intenta más tarde.',
      }
      setError(msgs[err.code] || 'Error al iniciar sesión')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md page-fade">
        <div className="text-center mb-8">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-brand-gradient flex items-center justify-center mb-4
                          shadow-[0_14px_34px_-10px_rgba(255,184,0,0.65),inset_0_2px_0_rgba(255,255,255,0.55),inset_0_-5px_12px_rgba(0,0,0,0.4)]">
            <LogIn className="w-8 h-8 text-gray-950 drop-shadow" />
          </div>
          <h1 className="text-3xl font-extrabold brand-mark tracking-tight">YANGO</h1>
          <p className="text-gray-400 text-sm mt-1">Buscador de Líneas GPS</p>
        </div>

        <form onSubmit={handleSubmit} className="card p-7 space-y-5">
          <div>
            <h2 className="text-white font-semibold text-lg">Iniciar sesión</h2>
            <p className="text-gray-500 text-xs mt-1">Accede a tu panel de control</p>
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-xl text-red-300 text-sm">
              <AlertCircle className="w-4 h-4 shrink-0" />
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs text-gray-400 mb-1.5">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="input"
              placeholder="usuario@yangogps.com"
            />
          </div>

          <div>
            <label className="block text-xs text-gray-400 mb-1.5">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="input"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary w-full py-3"
          >
            {loading
              ? <><Loader2 className="w-4 h-4 animate-spin" /> Entrando...</>
              : <><LogIn className="w-4 h-4" /> Entrar</>
            }
          </button>
        </form>

        <p className="text-center text-xs text-gray-600 mt-6">{APP_TAG}</p>
      </div>
    </div>
  )
}
